import { Card } from "@/components/ui/Card";

import {
  describeWellnessAllotment,
  formatReimbursementMoney,
  type WellnessAllotment,
} from "./reimbursementApi";

export function WellnessAllotmentNotice({
  allotment,
  thisAmount,
}: {
  allotment: WellnessAllotment;
  thisAmount: number;
}): JSX.Element {
  const described = describeWellnessAllotment(allotment, thisAmount);
  return (
    <Card className={described.warning ? "border-amber-300 bg-amber-50 p-4" : "p-4"}>
      <p className="text-sm text-slate-800">{described.summary}</p>
      {allotment.pendingUsd > 0 ? (
        <p className="mt-1 text-sm text-slate-600">
          {formatReimbursementMoney(allotment.pendingUsd)} is still waiting on Accounting this year.
        </p>
      ) : null}
      {described.warning ? <p className="mt-2 text-sm font-medium text-amber-950">{described.warning}</p> : null}
    </Card>
  );
}
